const formatString = (str) => ` ${str.toLowerCase()}`;

export default formatString;
